import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, useResource, useStore, useToast, usePage, useTheme } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import {
    BASE,
    URLS,
    APIS,
    SF_HLDY_MGMT_SRCH,
    SG_HLDY_MGMT_LIST,
} from "@/tra/tancis/ptli/crtr/hldy/services/PtliHldyMgmtService";
import constants from "@/comn/constants";
import dayjs from "dayjs";

/*
 * Holiday Management List
 * !== 휴일 관리 목록 ==!
 */
export const PTLI0408001Q = (props: any) => {
    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "COM0057" }, { area: "cstmCd" }],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0003"],
    });

    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const { theme } = useTheme();
    const lang = theme.lang;
    const dateFormat = constants.DATE_FORMAT_DAYJS[lang];

    const form = {
        hldyMgmtSrch: useForm({
            defaultSchema: SF_HLDY_MGMT_SRCH,
            defaultValues: { ...pgeStore?.form, startDate: comnUtils.getDate({ m: -1 }), endDate: comnUtils.getDate() },
        }),
    };

    const grid = {
        hldyMgmtList: useGrid({
            defaultSchema: SG_HLDY_MGMT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        // Retrieve a list of region codes. !== 지역코드 목록을 조회한다.==!
        getHldyMgmtList: useFetch({
            api: (page = grid.hldyMgmtList.page) =>
                APIS.getHldyMgmtList(form.hldyMgmtSrch.getValues(), page, grid.hldyMgmtList.size),
            enabled: comnUtils.isEmpty(form.hldyMgmtSrch.errors) && form.hldyMgmtSrch.isSubmitted,
            key: [grid.hldyMgmtList.page, grid.hldyMgmtList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.hldyMgmtSrch.getValues(),
                    page: grid.hldyMgmtList.page,
                    size: grid.hldyMgmtList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const render = {
        cell: {
            ctraDt: (props: any) => {
                const { rowValues, value } = props;
                return <Link to={`${URLS.ptli0408003s}/${rowValues.hldyId}`}>{dayjs(value).format(dateFormat)}</Link>;
            },
        },
    };

    const handler = {
        getHldyMgmtList: () => {
            form.hldyMgmtSrch.handleSubmit(() => {
                grid.hldyMgmtList.setPage(0);
                fetch.getHldyMgmtList.fetch(0);
            })();
        },
    };

    useEffect(() => {
        handler.getHldyMgmtList();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.hldyMgmtSrch.schema.ctraDt} />
                            <Group.Control {...form.hldyMgmtSrch.schema.hldyTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.hldyMgmtSrch.schema.hldyNm} />
                            <Group.Control {...form.hldyMgmtSrch.schema.cstmOfceCd} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.hldyMgmtSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.getHldyMgmtList} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.hldyMgmtList.grid}
                            data={fetch.getHldyMgmtList.data?.hldyMgmtList}
                            render={render}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout.Left>
                <Button
                    role={"new"}
                    onClick={() => {
                        navigate(`${URLS.ptli0408002s}?menuId=${menuId}`);
                    }}
                />
            </Layout.Left>
        </Page>
    );
};
